export const itemCodeGenerator: () => string = () =>
  `T${Math.floor(Math.random() * 90000000000 + 10000000000)}`;

export const productIdGenerator = () =>
  Math.floor(Math.random() * 900000000000 + 10000000000);
